<template>
  <div class="box">
    <div class="row">
      <div class="searchForm">
        <div class="col" :class="[(active === 0 ? 'colActive' : '')]">
          <div class="label">{{$t('util.mddgjz')}}</div>
          <input type="text" class="ipt" v-model="kw" :placeholder="$t('util.mddgjz')" @focus="()=>{active=0}" @blur="()=>{active=''}" />
        </div>
        <div class="horBorder" />
        <div class="col" :class="[(active === 1 ? 'colActive' : '')]">
          <div class="vDate" @click="handleHotelDatePick">
            <div class="date">
              <div class="label">{{$t('util.rzrq')}}</div>
              <span class="ipt" >{{ checkInText }}</span>
            </div>
            <span class="vNight">{{ vNight }}{{$t('util.w')}}</span>
            <div class="date">
              <div class="label">{{$t('util.ldrq')}}</div>
              <span class="ipt" >{{ checkOutText }}</span>
            </div>
          </div>
          <el-date-picker :picker-options="pickOption" style="opacity: 0;height: 0;position: absolute;bottom: 0" type="daterange" range-separator="~" v-model="dateRange" ref="hotelDateRange" size="large" @focus="()=>{active=1}" @blur="()=>{active=''}" />
        </div>
        <div class="horBorder" />
        <div class="col" style="width: 260px;flex-shrink: 0;" :class="[(active === 2 ? 'colActive' : '')]">
          <div class="label">{{$t('util.fjzks')}}</div>
          <el-popover
            placement="bottom"
            width="260"
            v-model="roomInfoVisible"
            @show="()=>{active=2}"
            @hide="()=>{active=''}"
          >
            <div class="listForm">
              <div class="li">
                <label>{{$t('util.fjs')}}</label>
                <el-input-number v-model="roomNum" :min="1" :max="10" />
              </div>
              <div class="li">
                <label>{{$t('util.crs')}}<small style="color: #b94a48">(每房)</small></label>
                <el-input-number v-model="adult" :min="1" :max="10" />
              </div>
              <div class="li">
                <label>{{$t('util.ets')}}<small style="color: #b94a48">(每房)</small></label>
                <el-input-number v-model="child" :min="0" :max="10" />
              </div>
              <div class="li">
                <span></span>
                <el-button type="success" plain @click="roomInfoVisible = false">{{$t('util.qd')}}</el-button>
              </div>
            </div>
            <div class="ipt" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center" slot="reference">
              <span class="ipt">{{ roomNum }}{{$t('util.j')}}·{{adult}}{{$t('util.cr')}}·{{child}}{{$t('util.xt')}}</span>
              <i class="el-icon-arrow-down" />
            </div>
          </el-popover>
        </div>
      </div>
      <el-button type="success" plain size="medium" class="btn" @click="search">{{$t('util.ss')}}</el-button>
    </div>
    <div class="row" style="margin-top: 15px">
      <div style="font-size: 14px;color: #666;margin-right: 12px">{{$t('util.jdxj')}}</div>
      <el-tag
        @click="handleHotelStar(5)"
        :type="(hotelStart.indexOf(5) >= 0 ? 'success' : '')"
        effect="plain" size="medium" style="margin-right: 8px">
        5<i class="el-icon-star-off" />
      </el-tag>
      <el-tag
        @click="handleHotelStar(4)"
        :type="(hotelStart.indexOf(4) >= 0 ? 'success' : '')"
        effect="plain" size="medium" style="margin-right: 8px">
        4<i class="el-icon-star-off" />
      </el-tag>
      <el-tag
        @click="handleHotelStar(3)"
        :type="(hotelStart.indexOf(3) >= 0 ? 'success' : '')"
        effect="plain" size="medium" style="margin-right: 8px">
        3<i class="el-icon-star-off" />
      </el-tag>
      <el-tag
        @click="handleHotelStar(2)"
        :type="(hotelStart.indexOf(2) >= 0 ? 'success' : '')"
        effect="plain" size="medium" style="margin-right: 8px">
        &lt;= 2<i class="el-icon-star-off" />
      </el-tag>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'SearchBoxHotel',
  data () {
    return {
      kw: '',
      hotelStart: [],
      dateRange: [dayjs().add(1, 'day').toDate(), dayjs().add(2, 'day').toDate()],
      roomNum: 1,
      adult: 2,
      child: 0,
      active: '',
      roomInfoVisible: false
    }
  },
  props: {
    pickOption: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    vNight () {
      return dayjs(this.dateRange[1]).diff(dayjs(this.dateRange[0]), 'days')
    },
    checkInText () {
      return dayjs(this.dateRange[0]).format('YYYY年MM月DD日')
    },
    checkOutText () {
      return dayjs(this.dateRange[1]).format('YYYY年MM月DD日')
    }
  },
  methods: {
    search () {
      this.$router.push({
        path: '/hotel/list',
        query: {
          kw: this.kw,
          hotelStart: this.hotelStart,
          dateRange: [dayjs(this.dateRange[0]).format('YYYY-MM-DD'), dayjs(this.dateRange[1]).format('YYYY-MM-DD')],
          roomNum: this.roomNum,
          adult: this.adult,
          child: this.child
        }
      })
      console.log(123)
    },
    handleHotelDatePick () {
      this.$refs.hotelDateRange.focus()
    },
    handleHotelStar (e) {
      let has = false
      for (let x in this.hotelStart) {
        if (this.hotelStart[x] === e) {
          has = true
          this.hotelStart.splice(x, 1)
        }
      }
      if (!has) {
        this.hotelStart.push(e)
      }
      console.log(this.hotelStart)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../searchBox.scss";
.box{
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/global/searchBox/components/hotel.vue